import React from 'react';
import { Video, staticFile } from 'remotion';

export const RecruitingVideoFile = () => {
  return <Video src={staticFile('TheDesertNorthOpportunity_Base_v2.mp4')} />;
};


